import AppState from '../../types/app-state'
import {UserAgentApplication} from 'msal'

export const authTokenSelector = (state: AppState): string | undefined => state.auth.authToken

export const hasAuthTokenSelector = (state: AppState): boolean =>
    state.auth.authToken ? state.auth.authToken?.length > 0 : false

export const msalSelector = (state: AppState): UserAgentApplication | undefined => state.auth.msal
